/**
 * The largest font size, in rem, between `minRem` and `maxRem` at which text still fits: steps down from `maxRem` by
 * `stepRem` while `overflows(rem)` says it doesn't fit, and stops at `minRem` (where an ellipsis takes over).
 * `overflows` should apply the size and measure; keeping that out of here keeps this testable without a layout engine.
 */
export function fitRem(overflows: (rem: number) => boolean, maxRem: number, minRem: number, stepRem = 0.0625): number {
  let rem = maxRem;
  while (rem > minRem && overflows(rem)) rem = Math.max(minRem, rem - stepRem);
  return Math.round(rem * 10000) / 10000;
}
